// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__O3cgl","title":"Info_title__2bkxv","links":"Info_links__1AGfK","link":"Info_link__1RzeQ","logo":"Info_logo__EQavL"};